// home index

import React from 'react';
import { particlesConfig } from '../../config/particles_config'
import Particles from 'react-particles-js';
import To1pxSvg from './to1px.js';
import worksImage from  '../../images/home/works.jpg';
import serviceImage from  '../../images/home/service.jpg';
import recruitImage from  '../../images/home/recruit.jpg';
import worksImageSp from  '../../images/home/works_sp.jpg';
import serviceImageSp from  '../../images/home/service_sp.jpg';
import recruitImageSp from  '../../images/home/recruit_sp.jpg';
import Responsive from '../Responsive/Responsive';
import ContentsTemplate from './contentsTemplate';
import { initGA } from '../GA'; 
import Helmet from "../Helmet";
import APP_CONFIG from "../../config/app.json"

export class Home extends React.Component {
  
  componentDidMount(){
    initGA();
  }

  render() {
    return (
      <React.Fragment>
        <Helmet description={APP_CONFIG.description} />
        <div className="particles-js">
          <Responsive name="pc">
            <Particles params={particlesConfig} />
          </Responsive>
        </div>

        <To1pxSvg />

        <ContentsTemplate
          id = "service"
          src = {serviceImage}
          sp_src = {serviceImageSp}
          comment = "1ピクセルにこだわるWEBサービス"
        />
        <ContentsTemplate
          id = "company"
          src = {worksImage}
          sp_src = {worksImageSp}
          comment = "会社概要"
          reverse = "l-reverse"
          text_position = "intro-text-right"
          
        />
        <ContentsTemplate
          id = "recruit"
          src = {recruitImage}
          sp_src = {recruitImageSp}
          comment = "採用情報"
        />
        
      </React.Fragment>
    )
  }
}



// WEBPACK FOOTER //
// ./src/component/home/index.js